var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2C6.46243 2 4 4.46243 4 7.5C4 10.5376 6.46243 13 9.5 13C12.5376 13 15 10.5376 15 7.5C15 4.46243 12.5376 2 9.5 2ZM6 7.5C6 5.567 7.567 4 9.5 4C11.433 4 13 5.567 13 7.5C13 9.433 11.433 11 9.5 11C7.567 11 6 9.433 6 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 2.31323C15.8128 2.12918 15.2415 2.40211 15.0574 2.92282C14.8734 3.44354 15.1463 4.01486 15.667 4.19891C17.0278 4.67986 18.0003 5.97765 18.0003 7.50001C18.0003 9.02237 17.0278 10.3202 15.667 10.8011C15.1463 10.9852 14.8734 11.5565 15.0574 12.0772C15.2415 12.5979 15.8128 12.8708 16.3335 12.6868C18.4684 11.9322 20.0003 9.89631 20.0003 7.50001C20.0003 5.10372 18.4684 3.06779 16.3335 2.31323Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C2 16.6863 4.68629 14 8 14H11C14.3137 14 17 16.6863 17 20V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V20C15 17.7909 13.2091 16 11 16H8C5.79086 16 4 17.7909 4 20V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V20Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 19.9998C21.9998 17.779 20.7931 15.84 18.9997 14.8025C17.4997 13.9346 16.4999 15.6672 17.9997 16.535C19.1953 17.2266 19.9997 18.5193 19.9997 19.9998V20.9998C19.9997 21.5521 20.4475 21.9998 20.9997 21.9998C21.552 21.9998 21.9998 21.5521 21.9998 20.9998V19.9998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.91ebc4864f28a305afdf89f8e6d66a11.svg";
export { ForwardRef as ReactComponent };